export default [
  {
    position: "absolute",
    top: 24.2,
    left: 8,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "passport.persona1.mTitleOne",
    mBody: "passport.persona1.mBodyOne",
    isVideo: true,
    videoThumb: "OB-Passport-Thumb",
    videoURL: "OB-Passport.mp4",
    vidIcon: true,
    id: "OB_PassportInformation_Video_HRAutomation",
    index: 0,
  },
  {
    position: "absolute",
    top: 9.5,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "passport.persona1.ttTextOne",
    hover: false,
    id: "OB_PassportInformation_Navigation_Homepage",
    index: 1,
  },
  {
    position: "absolute",
    top: 7,
    left: 32.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "passport.persona1.ttTextTwo",
    hover: false,
    id: "OB_PassportInformation_Navigation_PersonalDetails",
    index: 2,
  },
  {
    position: "absolute",
    top: 7,
    left: 60.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "passport.persona1.ttTextThree",
    hover: false,
    id: "OB_PassportInformation_Navigation_Policies",
    index: 3,
  },
  {
    position: "absolute",
    top: 7,
    left: 69.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "passport.persona1.ttTextFour",
    hover: false,
    id: "OB_PassportInformation_Navigation_Feedback",
    index: 4,
  },
  {
    position: "absolute",
    top: 1,
    left: 87.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "passport.persona1.ttTextFive",
    hover: false,
    tooltipClass: "left",
    id: "OB_PassportInformation_Navigation_Actions",
    index: 5,
  },
];
